import { Command } from './Commands';

export class ChangePageVisibility extends Command {
  priority: number = 100;
  constructor(public value: string, id: string) {
    super(value, id);
  }
  type: string = 'Page.ChangeVisibility';
}
